import { gsap } from "gsap";
import { Flip } from "gsap/Flip";

gsap.registerPlugin(Flip);

const InterviewFilter = () => {
  const grid          = document.querySelector('.js-interviewGrid');
  const btnAll        = document.querySelector('.js-interviewAll');
  const filterSystemEl = document.querySelector('.js-interviewFilterSystem');
  const filterCourseEl = document.querySelector('.js-interviewFilterCourse');
  const emptyMsg      = document.querySelector('.js-interviewEmpty');

  if(!grid || !btnAll || !filterSystemEl || !filterCourseEl || !emptyMsg) return;

  const active = { system: null, course: null };

  // 色パターン定義
  const COLORS = [
    { linear: 'linear-gradient(180deg, #628DFC 0%, #415FD2 100%)', color: '#415FD2' },  // blue
    { linear: 'linear-gradient(180deg, #04BBC5 0%, #03A7B0 111.3%)', color: '#04BBC5' }, // teal
    { linear: 'linear-gradient(180deg, #fccb62, #d28241)', color: '#DE974B' },            // orange
  ];
  // PC: 3列 → 9個周期 (0-indexed)
  const PC_PATTERN = [0, 1, 2, 2, 0, 1, 1, 2, 0];
  // SP: 1列 → 3個周期 (0-indexed)
  const SP_PATTERN = [0, 1, 2];

  const mqSP = window.matchMedia('(width < 768px)');

  function applyColors() {
    const cards = [...grid.querySelectorAll('.js-interviewCard')];
    const pattern = mqSP.matches ? SP_PATTERN : PC_PATTERN;
    let visibleIndex = 0;
    cards.forEach(card => {
      if (!card.classList.contains('is-hidden')) {
        const colorIndex = pattern[visibleIndex % pattern.length];
        const c = COLORS[colorIndex];
        card.style.setProperty('--bg_linear', c.linear);
        card.style.setProperty('--bg_color', c.color);
        visibleIndex++;
      } else {
        card.style.removeProperty('--bg_linear');
        card.style.removeProperty('--bg_color');
      }
    });
  }

  function applyFilter() {
    const cards = [...grid.querySelectorAll('.js-interviewCard')];
    const state = Flip.getState(cards);

    // 変更前に高さをロックして崩れを防ぐ
    const oldHeight = grid.offsetHeight;
    grid.style.height = oldHeight + 'px';
    grid.style.overflow = 'hidden';

    let visibleCount = 0;
    cards.forEach(card => {
      const system = card.dataset.system ? card.dataset.system.split(' ') : [];
      const course = card.dataset.course ? card.dataset.course.split(' ') : [];
      const matchSystem = !active.system || system.includes(active.system);
      const matchCourse = !active.course || course.includes(active.course);
      const show = matchSystem && matchCourse;
      card.classList.toggle('is-hidden', !show);
      if (show) visibleCount++;
    });

    applyColors();

    emptyMsg.style.display = visibleCount === 0 ? 'block' : 'none';
    btnAll.classList.toggle('is-act', !active.system && !active.course);

    // 変更後の高さを計測（一瞬autoにして測る）
    grid.style.height = 'auto';
    const newHeight = grid.offsetHeight;
    grid.style.height = oldHeight + 'px';

    // 高さアニメーション
    gsap.to(grid, {
      height: newHeight,
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: () => {
        grid.style.height = '';
        grid.style.overflow = '';
      },
    });

    Flip.from(state, {
      duration: 0.5,
      ease: 'power2.inOut',
      absolute: true,
      onEnter: els => gsap.fromTo(els, { opacity: 0 }, { opacity: 1, duration: 0.4 }),
      onLeave: els => gsap.to(els, { opacity: 0, duration: 0.3 }),
    });
  }

  btnAll.addEventListener('click', () => {
    active.system = null;
    active.course = null;
    [...filterSystemEl.querySelectorAll('.js-interviewBtn'),
     ...filterCourseEl.querySelectorAll('.js-interviewBtn')].forEach(b => b.classList.remove('is-act'));
    applyFilter();
  });

  filterSystemEl.addEventListener('click', e => {
    const btn = e.target.closest('.js-interviewBtn');
    if (!btn) return;
    const val = btn.dataset.filter;
    if (active.system === val) {
      active.system = null;
      btn.classList.remove('is-act');
    } else {
      filterSystemEl.querySelectorAll('.js-interviewBtn').forEach(b => b.classList.remove('is-act'));
      active.system = val;
      btn.classList.add('is-act');
    }
    applyFilter();
  });

  filterCourseEl.addEventListener('click', e => {
    const btn = e.target.closest('.js-interviewBtn');
    if (!btn) return;
    const val = btn.dataset.filter;
    if (active.course === val) {
      active.course = null;
      btn.classList.remove('is-act');
    } else {
      filterCourseEl.querySelectorAll('.js-interviewBtn').forEach(b => b.classList.remove('is-act'));
      active.course = val;
      btn.classList.add('is-act');
    }
    applyFilter();
  });

  // 初期表示時に色を適用
  applyColors();

  // PC⇔SP切替時に色パターンを再適用
  mqSP.addEventListener('change', applyColors);
};

export default InterviewFilter;
